export default function setCanonicalUrl(url = '') {
  document.head
    .querySelector('link[rel="canonical"]')
    .setAttribute('href', url);
}
